import React, { useState, useEffect } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Alert,
  Label,
  Input,
  Badge,
  FormGroup,
  Button,
} from "reactstrap"
import { post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { Link, useLocation, useNavigate } from "react-router-dom"
import Loader from "common/loader"
import Select from "react-select"
import { PARTNERS_BRANCH_SEARCH } from "helpers/api_endpoints"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"

//meta title
document.title = "Partners Branch"

const PartnersBranchList = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const [partnersBranch, setPartnersBranch] = useState([])
  const [cPartnersBranch, setCPartnersBranch] = useState([])
  const [filteredPartnersBranch, setFilteredPartnersBranch] = useState([])
  const [filters, setFilters] = useState({})
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [successMsg, setsuccessMsg] = useState("")
  const [errorMsg, seterrorMsg] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
	const user = JSON.parse(localStorage.getItem('authUser')).user;

  useEffect(() => {
    if (location.state) {
        if (location.state.successMsg) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                setsuccessMsg("");
                navigate(location.pathname, { replace: true, state: {} });
            }, 4000);
        }
        if (location.state.errorMsg) {
            seterrorMsg(location.state.errorMsg);
            setTimeout(() => {
                seterrorMsg("");
                navigate(location.pathname, { replace: true, state: {} });
            }, 4000);
        }
    }
    
    if(user.partner)
      filters.partnerId = user.partner.id;
    post(`${PARTNERS_BRANCH_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`, filters)
        .then(response => {
            const data = response.data;
            setPartnersBranch(data.data);
            setFilteredPartnersBranch(data.data); // Initialize filtered data
            setTotalPages(data.pagination.totalPages);
            setPage(data.pagination.currentPage);
            setLoading(false);
        })
        .catch(error => {
            if (error?.response?.status == 400) {
                console.log(error)
            }
            setLoading(false)
        })
  }, [page, filters, location.state, navigate, location.pathname]);

  useEffect(() => {
    // Apply search filter whenever searchQuery or partnersBranch changes
    if (searchQuery) {
      if(cPartnersBranch ==undefined)
        return;
      const filtered = cPartnersBranch.filter(branch => 
        String(branch.id).includes(searchQuery) || // Search by ID
        (branch?.name?.toLowerCase().includes(searchQuery.toLowerCase())) || // Search by branch name
        (branch?.partner?.name?.toLowerCase().includes(searchQuery.toLowerCase()))) // Search by partner name
      setFilteredPartnersBranch(filtered)
    } else {
      setFilteredPartnersBranch(partnersBranch)
    }
  }, [searchQuery, partnersBranch])

  useEffect(() => {
    post(`${PARTNERS_BRANCH_SEARCH}`)
        .then(response => {
            const data = response.data;
            setCPartnersBranch(data);
        })
        .catch(error => {
            if (error?.response?.status == 400) {
                console.log(error)
            }
        })
  }, [])

  const handleSearch = (e) => {
    e.preventDefault()
    // Client-side filtering happens automatically via useEffect
  }

  const handleClearSearch = () => {
    setSearchQuery('')
  }

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Partners Branch" />
          <Row>
            <Col xl={12}>
              <Card>
                <br></br>
                {successMsg ? (
                  <Alert style={{ margin: "25px" }} color="success">
                    {successMsg}
                  </Alert>
                ) : null}
                
                {/* Search Box */}
                <CardBody>
                  <form onSubmit={handleSearch}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="search">Search</Label>
                          <div className="d-flex">
                            <Input
                              type="text"
                              id="search"
                              name="search"
                              placeholder="Search by ID, partner name, or branch name..."
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <Button 
                              type="submit" 
                              color="primary" 
                              className="ms-2"
                            >
                              <i className="fas fa-search"></i>
                            </Button>
                            {searchQuery && (
                              <Button 
                                color="secondary" 
                                className="ms-2"
                                onClick={handleClearSearch}
                              >
                                <i className="fas fa-times"></i>
                              </Button>
                            )}
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </form>
                </CardBody>

                <CardTitle>
                  <Link to="/partnersbranch/add">
                    <button
                      style={{ float: "right", marginRight: "20px" }}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="dripicons-plus"></i> &nbsp;
                      <Trans>Create</Trans>
                    </button>
                  </Link>
                </CardTitle>

                <CardBody>
                {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                  <div className="table-responsive">
                    <Table className="table table-striped table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>
                            <Trans>ID</Trans>
                          </th>
                          <th>
                            <Trans>Partner Branch Name</Trans>
                          </th>
                          <th>
                            <Trans>Partner Name</Trans>
                          </th>
                          <th>
                            <Trans>Status</Trans>
                          </th>
                          <th>
                            <Trans>Preparation Time (min)</Trans>
                          </th>
                          <th>
                            <Trans>Delivery Time (min)</Trans>
                          </th>
                          <th>#</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <th colSpan={8} className="text-center">
                              <Loader></Loader>
                            </th>
                          </tr>
                        ) : null}
                        {filteredPartnersBranch.length === 0 && !loading ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              <Trans>No partners branch found</Trans>
                              {searchQuery && (
                                <div>
                                  <Trans>for search term:</Trans> "{searchQuery}"
                                </div>
                              )}
                            </td>
                          </tr>
                        ) : null}
                        {filteredPartnersBranch.map((partnerbranch, index) => (
                          <tr key={index}>
                            <td>{partnerbranch.id}</td>
                            <td>{partnerbranch.name}</td>
                            <td>{partnerbranch?.partner?.name}</td>
                            <td>
                              {
                                <Badge
                                  className={
                                    partnerbranch.status == 2
                                      ? "bg-danger"
                                      : "bg-success"
                                  }
                                >
                                  <Trans>
                                    {partnerbranch.status == 2
                                      ? "inactive"
                                      : "active"}
                                  </Trans>
                                </Badge>
                              }
                            </td>
                            <td>{partnerbranch.preparationTime}</td>
                            <td>{partnerbranch.deliveryTime}</td>
                            <td>
                              <Link to={`/partnersbranch/edit/${partnerbranch.id}`}>
                                <button className="btn btn-sm btn-info">
                                  <i className="dripicons-pencil"></i> &nbsp;
                                  <Trans>Edit</Trans>
                                </button>
                              </Link>{" "}
                              &nbsp;
                              <Link to={`/partnersbranch/remove/${partnerbranch.id}`}>
                                <button className="btn btn-sm btn-danger">
                                  <i className="dripicons-trash"></i> &nbsp;
                                  <Trans>Remove</Trans>{" "}
                                </button>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <br></br>
                  <div className="text-center">
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handlePrevPage}
                      disabled={page === 1}
                    >
                      <Trans>Previous</Trans>
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handleNextPage}
                      disabled={page === totalPages}
                    >
                      <Trans>Next</Trans>
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PartnersBranchList